module.exports = __webpack_public_path__ + "img/type-red.862dc7dd.png";